import React from 'react';
import { StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
  SkeletonList,
  SkeletonTextBlock,
} from '@/components/common/skeleton';

export const BulletinsListSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    <SkeletonList count={4} gap={12}>
      <SkeletonCard>
        <SkeletonBone width={80} height={14} />
        <SkeletonBone width="85%" height={18} />
        <SkeletonTextBlock lines={2} lineHeight={14} lastLineWidth="70%" />
      </SkeletonCard>
    </SkeletonList>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
});
